// extracted by mini-css-extract-plugin
export default {"JsonDisplay":"jSCKlatXQzfBTHxm178G","clickable":"bIK6VOgm8XICyANTG1Fy"};